import { render, staticRenderFns } from "./keyUpdateModal.vue?vue&type=template&id=bd4c536c&scoped=true"
import script from "./keyUpdateModal.vue?vue&type=script&lang=js"
export * from "./keyUpdateModal.vue?vue&type=script&lang=js"
import style0 from "./keyUpdateModal.vue?vue&type=style&index=0&id=bd4c536c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4c536c",
  null
  
)

export default component.exports